import { TransformType } from '@mr-yum/cdn-image'
import { Image } from 'components/Shared/Image'
import { GuestImage } from 'lib/gql'
import React from 'react'

interface Props {
  banner?: GuestImage | null
}

export const ConfirmationBanner = ({ banner }: Props) => {
  return (
    <div className="relative min-h-[90px] w-full bg-surface">
      {banner && (
        <Image
          image={banner}
          transform={TransformType.MOBILE_BANNER}
          sizes="100vw"
          layout="fill"
          objectFit="cover"
        />
      )}
    </div>
  )
}
